import { apiSlice } from './apiSlice';
import type { User } from '../../types';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<{ accessToken: string; refreshToken: string; user: User }, { username: string; password: string }>({
      query: (credentials) => ({ url: '/auth/login', method: 'POST', body: JSON.stringify(credentials), headers: { 'Content-Type': 'application/json' } }),
      invalidatesTags: ['Auth'],
      transformResponse: (response: any) => response?.data ?? response
    }),

    logout: builder.mutation<void, void>({
      query: () => ({ url: '/auth/logout', method: 'POST' }),
      invalidatesTags: ['Auth'],
      transformResponse: (response: any) => response?.data ?? response
    }),

    refreshToken: builder.mutation<{ accessToken: string }, { refreshToken: string }>({
      query: (body) => ({ url: '/auth/refresh', method: 'POST', body }),
      transformResponse: (response: any) => response?.data ?? response
    }),

    getProfile: builder.query<User, void>({
      query: () => ({ url: '/auth/profile', method: 'GET' }),
      providesTags: ['Auth'],
      transformResponse: (response: any) => response?.data ?? response
    }),

    updateProfile: builder.mutation<User, Partial<User>>({
      query: (body) => ({ url: '/auth/me', method: 'PUT', body }),
      transformResponse: (response: any) => response?.data ?? response
    }),

    changePassword: builder.mutation<any, { currentPassword: string; newPassword: string }>({
      query: (body) => ({ url: '/auth/password', method: 'PUT', body }),
      transformResponse: (response: any) => response?.data ?? response
    })
  })
});

export const { useLoginMutation, useLogoutMutation, useRefreshTokenMutation, useGetProfileQuery, useUpdateProfileMutation, useChangePasswordMutation } = authApi; 